/**
 * Check if a JWT access token has expired and needs refresh.
 * Returns true if the token IS expired, false if still valid or null.
 *
 * Port of packages/oauth/utilities.js shouldRefreshTokens()
 */
export function shouldRefreshToken(
  accessToken: string | null | undefined
): boolean {
  if (!accessToken) return false;
  let exp = 0;

  try {
    const [, payload] = accessToken.split(".");
    if (!payload) return false;
    ({ exp } = JSON.parse(atob(payload)));
  } catch {
    return false;
  }

  const expiresAt = new Date(exp * 1000).valueOf();
  const now = Date.now();
  return expiresAt < now;
}

/**
 * Decode a JWT token payload without verification.
 *
 * Port of packages/oauth/utilities.js readJWT()
 */
export function readJWT(jwt: string): Record<string, unknown> {
  try {
    const [, token] = jwt.split(".");
    if (!token) return {};
    return JSON.parse(atob(token));
  } catch {
    return {};
  }
}
